import { ChangeEvent } from "react";
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form";

export function handleFieldChange<T extends FieldValues>(
  field: ControllerRenderProps<T, Path<T>>,
  value: unknown,
) {
  field.onChange({
    target: {
      value: value,
    },
  } as ChangeEvent<HTMLInputElement>);
}
